import { uidGenerator } from "@/lib/Helpers/uidGenerator";
import { setClickId } from "@/lib/Helpers/getFreshClickId";

export function createAndAppendClickId(searchId: string): string {
  const newClickId = uidGenerator().generate(searchId);
  // Store in memory instead of replaceState — replaceState triggered GTM's
  // history hook which caused extractElementsFromDataLayerItem to recurse
  // infinitely in lastminute.js (MKTP-258).
  setClickId(newClickId);
  return newClickId;
}
